/* eslint-disable eslint-comments/disable-enable-pair, max-len */
const autopromoButtonCopy = 'Sprawdź teraz';

const slideCommon = {
  containerAlign: 'left',
  isCenterAlign: false,
  darkFontVersion: false,
  imgUrl: [
    {
      imgs: [
        {
          url: 'mobile1x',
          density: 1
        },
        {
          url: 'mobile2x',
          density: 2
        },
        {
          url: 'mobile3x',
          density: 3
        }
      ],
      width: 360
    },
    {
      imgs: [
        {
          url: 'desktop1x',
          density: 1
        },
        {
          url: 'desktop2x',
          density: 2
        }
      ],
      width: 600
    }
  ],
  altText: 'Masz rękę do wszystkiego?',
  title: 'Masz rękę do wszystkiego?',
  subtitle: 'Oferty dla fachowców czekają!',
  buttons: [
    {
      img: [],
      altText: autopromoButtonCopy,
      text: autopromoButtonCopy,
      lightBgColor: true,
      url: 'https://www.pracuj.pl/praca?rd=30&cc=5036001%2C5009007%2C5010%2C5017002%2C5021006%2C5022%2C5024002%2C5028013%2C5031&et=1%2C3%2C17%2C4%2C18%2C19%2C2%2C5&utm_source=autopromo&utm_medium=cpc&utm_campaign=bc_21&utm_term=autopromo&utm_content=box',
      linkTitle: autopromoButtonCopy
    }
  ]
};

const slideDesktop = {
  isCenterAlignDesktop: false,
  title: 'Masz rękę do wszystkiego?',
  subtitle: 'Oferty dla fachowców czekają!',
  buttons: [
    {
      img: [],
      altText: autopromoButtonCopy,
      text: autopromoButtonCopy,
      lightBgColor: true,
      url: 'https://www.pracuj.pl/praca?rd=30&cc=5036001%2C5009007%2C5010%2C5017002%2C5021006%2C5022%2C5024002%2C5028013%2C5031&et=1%2C3%2C17%2C4%2C18%2C19%2C2%2C5&utm_source=autopromo&utm_medium=cpc&utm_campaign=bc_21&utm_term=autopromo&utm_content=box',
      linkTitle: autopromoButtonCopy
    }
  ]
};

export default { ...slideCommon, slideDesktop };
